// Vendors
import {
  TrackingUserStatusEnumeration,
  TrackingUserTypeEnumeration,
} from '@gruposantander/opbpay-ui-core-models';

const TRACKING_CONFIGURATION = {
  userId: '',
  userType: TrackingUserTypeEnumeration.PROSPECT,
  userStatus: TrackingUserStatusEnumeration.LOGGEDIN,
};

export { TRACKING_CONFIGURATION };
